/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import NoteConstants from 'constants/NoteConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const NoteQueries = Marty.createQueries({
  id: 'NoteQueries',

  fetchNotesForEndUserId(endUserId) {
    const promise = this.app.sources.NoteAPI.fetchNotesForEndUserId(endUserId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(NoteConstants.NOTE_LIST_FOR_END_USER_FETCH_DONE, endUserId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(NoteConstants.NOTE_LIST_FOR_END_USER_FETCH_FAILED, endUserId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(NoteConstants.NOTE_LIST_FOR_END_USER_FETCH_FAILED, endUserId, error)
    })
  },

  fetchNotesForCompanyId(companyId) {
    const promise = this.app.sources.NoteAPI.fetchNotesForCompanyId(companyId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(NoteConstants.NOTE_LIST_FOR_COMPANY_FETCH_DONE, companyId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(NoteConstants.NOTE_LIST_FOR_COMPANY_FETCH_FAILED, companyId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(NoteConstants.NOTE_LIST_FOR_COMPANY_FETCH_FAILED, companyId, error)
    })
  },

  notifyNoteCreation() {
    return this.app.actions.NotificationActions.pushNotification({
      content: 'Note has been saved!'
    })
  },

  createNoteForEndUserId(endUserId, note) {
    const promise = this.app.sources.NoteAPI.createNoteForEndUserId(endUserId, note)
    this.dispatch(NoteConstants.NOTE_END_USER_CREATE_STARTING, endUserId, note)
    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(NoteConstants.NOTE_END_USER_CREATE_DONE, endUserId, res.body)
        return this.notifyNoteCreation()
      } else {
        captureResponseException(res)
        return this.dispatch(NoteConstants.NOTE_END_USER_CREATE_FAILED, endUserId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(NoteConstants.NOTE_END_USER_CREATE_FAILED, endUserId, error)
    })
  },

  createNoteForCompanyId(companyId, note) {
    const promise = this.app.sources.NoteAPI.createNoteForCompanyId(companyId, note)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(NoteConstants.NOTE_COMPANY_CREATE_DONE, companyId, res.body)
        return this.notifyNoteCreation()
      } else {
        captureResponseException(res)
        return this.dispatch(NoteConstants.NOTE_COMPANY_CREATE_FAILED, companyId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(NoteConstants.NOTE_COMPANY_CREATE_FAILED, companyId, error)
    })
  }
})

export default NoteQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/NoteQueries.js